import { createAction, props } from '@ngrx/store';
import {
  FileItem,
  Answer,
  Consultation,
  IFile,
  IRequiredFormsParam,
  IFileUploadResponseDTO,
  IRequiredConsultation
} from '@care-portals/api-interfaces';
import { FormTypeQuestion } from '@appgen-health-crm/data';

// called on load of consultation/start page
export const getRequiredForms = createAction(
  '[Consultation] Get Required Forms from Order Id',
  props<{ query: IRequiredFormsParam }>()
);

export const getRequiredFormsSuccess = createAction(
  '[Consultation] Get Required Forms Success',
  props<{
    /** Outstanding questionnaires, each tagged with the engine that answers it. */
    consultations: IRequiredConsultation[];
    /** Pathwai entry point that runs the migrated questionnaires. */
    pathwaiStartUrl?: string;
    incompleteConsults: Consultation[];
  }>()
);

/**
 * Hand the patient over to Pathwai. Fired once patient-web has nothing left to
 * collect — either immediately (all questionnaires migrated) or after the last
 * legacy form is saved.
 */
export const redirectToPathwai = createAction(
  '[Consultation] Redirect To Pathwai',
  props<{ url: string }>()
);

export const getRequiredFormsFailure = createAction(
  '[Consultation] Get Required Forms Failure',
  props<{ error: any }>()
);

export const startConsultation = createAction(
  '[Consultation] Start consultation'
);

export const loadRequiredQuestions = createAction(
  '[Consultation] Load Required Questions'
);

export const loadRequiredQuestionsSuccess = createAction(
  '[Consultation] Load Required Questions Success',
  props<{ requiredQuestions: FormTypeQuestion[] }>()
);

export const loadRequiredQuestionsFailure = createAction(
  '[Consultation] Load Required Questions Failure',
  props<{ error: Error }>()
);

export const nextQuestion = createAction('[Consultation] Select Next Question');

export const nextQuestionSuccess = createAction(
  '[Consultation] Select Next Question Success',
  props<{ questionType?: string; qs: Array<number> }>()
);

export const setNextQuestion = createAction(
  '[Consultation] Set Next Question',
  props<{ questionType?: string }>()
);

export const prevQuestion = createAction('[Consultation] Select Prev Question');

export const storeAnswer = createAction(
  '[Consultation] Store Answer',
  props<{ selectedAnswer: any; states: any }>()
);

export const setAnswer = createAction(
  '[Consultation] Set Answer',
  props<{ answer: Answer }>()
);

export const setFileUploadAnswer = createAction(
  '[Consultation] Set FileUpload Answer'
);

export const setEsignAnswer = createAction('[Consultation] Set Esign Answer');

export const setImageListAnswer = createAction(
  '[Consultation] Set Image list Answer',
  props<{ answer: any }>()
);

export const setTransferRXAnswer = createAction(
  '[Consultation] Set TransferRX Answer',
  props<{ answer: any }>()
);

export const getFile = createAction(
  '[Consultation] Get File',
  props<{ name: string; resourceId: string }>()
);

export const getFileSuccess = createAction(
  '[Consultation] Get File Success',
  props<{ file: IFile; resourceId: string }>()
);

export const getFileFailure = createAction(
  '[Consultation] Get File Failure',
  props<{ error: any }>()
);

export const setRawFile = createAction(
  '[Consultation] Set Raw File',
  props<{ resourceId: string; fileItem: IFile }>()
);

export const saveFile = createAction(
  '[Consultation] Save File',
  props<{ resourceId: string; fileItem: IFile }>()
);

export const saveFileSuccess = createAction(
  '[Consultation] Save File Success',
  props<{ resourceId: string; fileItem: IFileUploadResponseDTO }>()
);

export const saveFileFailure = createAction(
  '[Consultation] Save File Failure',
  props<{ error: Error }>()
);

export const saveFiles = createAction(
  '[Consultation] Save Files',
  props<{ files: { resourceId: string; file: IFile }[] }>()
);

export const saveFilesSuccess = createAction(
  '[Consultation] Save Files Success',
  props<{ files: { resourceId: string; file: IFileUploadResponseDTO }[] }>()
);

export const saveFilesFailure = createAction(
  '[Consultation] Save Files Failure',
  props<{ error: Error }>()
);

export const saveForm = createAction('[Consultation] Save Form');

export const saveFormSuccess = createAction(
  '[Consultation] Save Form Success',
  props<{ completed: boolean; consultation: Consultation }>()
);

export const saveFormFailure = createAction(
  '[Consultation] Save Form Failure',
  props<{ error: Error }>()
);

export const nextForm = createAction('[Consultation] Select Next Form');

export const completedAllForms = createAction(
  '[Consultation] Completed All Required Forms'
);

export const nullAction = createAction('[Consultation] Null');

export const setDraftConsult = createAction(
  '[Consultation] Set Draft Consultation',
  props<{ draftConsult: Consultation }>()
);

export const deleteDraftConsult = createAction(
  '[Consultation] Delete Draft Consultation',
  props<{ formType: string }>()
);

export const deleteDraftConsultSuccess = createAction(
  '[Consultation] Delete Draft Consultation Success',
  props<{ formType: string }>()
);

export const deleteDraftConsultFailure = createAction(
  '[Consultation] Delete Draft Consultation Failure',
  props<{ error: any }>()
);
